import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/styles/globals.css'
import '@/styles/typography.css'
import '@/styles/animations.css'
import '@/styles/boot.css'
import '@/styles/utils.css'
import '@/styles/components.css'
import '@/styles/pages.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
